module.exports = __webpack_public_path__ + "media/images/logo-2724e650b74ad3762a87cca0a260b38f.png";